var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48.725mm",
    height: "60.906mm",
    viewBox: "0 0 48.725 60.906",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-41.638 -94.732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66 94.732c-12.79 0-24.362 9.8058-24.362 24.971 0 10.11 8.131 22.078 24.362 35.934 16.231-13.856 24.362-25.824 24.362-35.934 0-15.166-11.572-24.971-24.362-24.971zm-0.28557 23.886c-3.3498 0 0.42828 3.6591 0.42828 0.30962 0-3.3498-3.4212-0.046-0.0714-0.046 3.3498 0 0.0242-3.3261 0.0242 0.023 0 3.3498 2.9692-0.28544-0.38063-0.28544z",
    fill: "#898196",
    strokeWidth: 3.0453
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffd42a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.845,
    cy: 127.7,
    r: 3.0427
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.444,
    cy: 117.51,
    r: 3.0427
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.498,
    cy: 127.83,
    r: 3.0427
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.229,
    cy: 115.13,
    r: 3.0427
  })), /*#__PURE__*/React.createElement("path", {
    d: "m51.448 127.83 8.9958-10.583 10.054 10.848 8.9958-13.229",
    fill: "none",
    stroke: "#ffd42a",
    strokeWidth: 3
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.4e0ab2c03b4c5e199fe04ebf1e11a2cf.svg";
export { ForwardRef as ReactComponent };